module.exports = __webpack_public_path__ + "static/Merriweather-Regular-c97a9fc29652bb4afcdac68020e5d0f7.ttf";